import { type PropsWithChildren } from 'react'
// reason: export from third party lib not our own so no influence on its naming
// eslint-disable-next-line camelcase
import { ButtonBase, styled, unstable_memoTheme } from '@mui/material'
import { type BaseButtonProps } from '../../primitives/Button/BaseButton'

type Props = PropsWithChildren &
  BaseButtonProps & {
    /**
     * Fill the available height of the parent Card.
     * @default false
     */
    isStretched?: boolean
  }

const CardAreaRoot = styled(ButtonBase, {
  name: 'DhlCardArea',
  slot: 'Root',
  shouldForwardProp: (prop) => prop !== 'isStretched',
})<Pick<Props, 'isStretched'>>(
  unstable_memoTheme(({ theme }) => ({
    display: 'block',
    width: '100%',
    textAlign: 'inherit',
    fontSize: 'inherit',
    alignItems: 'flex-start',
    justifyContent: 'start',

    ...theme.misc.createHoverOrActiveState({
      backgroundColor: theme.palette.action.focus,
    }),

    '&:focus-visible': {
      backgroundColor: theme.palette.action.focus,
      outline: theme.misc.borderStyle('pure.dark', 2),
      outlineOffset: `-${theme.misc.borderSize(2)}`,
    },
  })),
  ({ isStretched }) =>
    isStretched && {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      alignItems: 'stretch',
      justifyContent: 'flex-start',
    }
)

export const BaseCardArea = ({ children, isStretched, ...rest }: Props) => (
  <CardAreaRoot component={rest.href ? 'a' : 'button'} isStretched={isStretched} {...rest}>
    {children}
  </CardAreaRoot>
)
